/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function() {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});
	
	jQuery('.wpforms-field input').on('keypress', function() {
		jQuery(this).parent().addClass('active');
	});
	
	jQuery('.wpforms-field textarea').on('keypress', function() {
		jQuery(this).parent().addClass('active');
	});
	
	jQuery('#expand-tables').on('click', function() {
		jQuery('.table--show-8-rows-only').removeClass('table--show-8-rows-only');
	});
	
	jQuery('#menu-toggler').on('click', function() {
		jQuery('#top-bar').removeClass('contact-opened');
		jQuery('#top-bar').toggleClass('menu-opened');
	});
	
	jQuery('#contact-toggler').on('click', function() {
		jQuery('#top-bar').removeClass('menu-opened');
		jQuery('#top-bar').toggleClass('contact-opened');
	});

	jQuery('#unsubscribe').on('submit', function() {
		var unsub_email = jQuery('#unsub-email').val();
		var unsub_phone = jQuery('#unsub-phone').val();

		var request = jQuery.ajax({
			url: "https://lundea.poslicek.com/api/change-contact-marketing-agree",
			type: "GET",
			data: { email: unsub_email, phoneNumber: unsub_phone },
			dataType: "html"
		});
		
		request.done(function(msg, status) {
			console.log( status );
			var result = JSON.parse(msg);
			console.log( result );

			if (status == "success") {
				jQuery('#unsubscribe').html('<div class="callout success">Odhlášení proběhlo úspěšně.</div>');
			} else {
				jQuery('#unsubscribe').html('<div class="callout alert">Tyto údaje v naší databázi neevidujeme.</div>');
			}
		});
		
		request.fail(function(jqXHR, textStatus) {
			console.log( "Request failed: " + textStatus );
			jQuery('#unsubscribe').html('<div class="callout alert">Při odhlašování nastala chyba. Zkuste to, prosím později.</div>');
		});
	});
}); 